import { config, gameState } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

var entrance = new Phaser.Geom.Point(0, 0);

var exitWay = new Phaser.Geom.Point(0, 0);

var startScreenp1 = new Phaser.Geom.Point(868, 394);
var startScreenp2 = new Phaser.Geom.Point(868, 190);
var startScreenp3 = new Phaser.Geom.Point(243, 190);
var startScreenp4 = new Phaser.Geom.Point(243, 394);

var startRouteCount = 1;

// var startRouteMap = [];

var startRouteMap = [startScreenp1, startScreenp2, startScreenp3, startScreenp4];

var plantPos3 = new Phaser.Geom.Point(320, 270);
var plantPos2 = new Phaser.Geom.Point(940, 270);
var plantPos4 = new Phaser.Geom.Point(320, 460);
var plantPos1 = new Phaser.Geom.Point(940, 460);

// var plantPos1 = new Phaser.Geom.Point(320,270);
// var plantPos2 = new Phaser.Geom.Point(940,270);
// var plantPos3 = new Phaser.Geom.Point(320,460);
// var plantPos4 = new Phaser.Geom.Point(940,460);

var leafArray = [];

var rect;
var graphics;
var points = [plantPos1, plantPos2, plantPos3, plantPos4];
var index = 0;

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: "StartScene",
    });
  }

  preload() {
    this.load.multiatlas("rewardAnim", "assets/EndSceneAssets/rewardAnim/rewardAnim.json", "assets/EndSceneAssets/rewardAnim");
    this.load.multiatlas("spotlight", "assets/EndSceneAssets/spotlight/spotlightAnimNew.json", "assets/EndSceneAssets/spotlight");
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);

    // var container = this.add.container(400, 300);

    this.add.sprite(config.width / 2, config.height / 2, "startSceneBG");

    // this.plant1 = this.add.sprite(320,270,"playSwayAnim").setScale(0.3).setTint(0xff0000);
    // this.plant2 = this.add.sprite(940,270,"playSwayAnim").setScale(0.3).setTint(0xff0000);

    // this.plant3 = this.add.sprite(320,460,"playSwayAnim").setScale(0.3).setTint(0xff0000);
    // this.plant4 = this.add.sprite(940,460,"playSwayAnim").setScale(0.3).setTint(0xff0000);

    this.add.sprite(425, 250, "startSceneText").setOrigin(0).setDepth(3);

    this.anims.create({
      key: "plantssway",
      frames: this.anims.generateFrameNames("playSwayAnim", {
        start: 0,
        end: 37,
        zeroPad: 0,
        prefix: "plantssway",
        suffix: ".png",
      }),
      frameRate: 25,
      repeat: -1,
    });

    this.anims.create({
      key: "flowering",
      frames: this.anims.generateFrameNames("flowering1Anim", {
        start: 0,
        end: 75,
        zeroPad: 0,
        prefix: "FLOWER",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.can = this.physics.add.sprite(868, 394, "wateringCanAnim").setDepth(3);

    this.anims.create({
      key: "startwatering",
      frames: this.anims.generateFrameNames("wateringCanAnim", {
        start: 1,
        end: 40,
        zeroPad: 0,
        prefix: "can",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "waterflowing",
      frames: this.anims.generateFrameNames("wateringCanAnim", {
        start: 10,
        end: 40,
        zeroPad: 0,
        prefix: "can",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "stopwatering",
      frames: this.anims.generateFrameNames("wateringCanAnim", {
        start: 41,
        end: 50,
        zeroPad: 0,
        prefix: "can",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "plantbudding",
      frames: this.anims.generateFrameNames("flowering1Anim", {
        start: 0,
        end: 31,
        zeroPad: 0,
        prefix: "FLOWER",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.createPlants();
    this.playButton = this.add
      .sprite(config.width / 2 - 22, 427, "playButton")
      .setOrigin(0.5, 0.5)
      .setInteractive({ cursor: "pointer" })
      .setDepth(4);
    this.waterThePlant(2000);

    this.time.delayedCall(
      3000,
      () => {
        this.moveCan(startRouteMap[0].x, startRouteMap[0].y, startRouteMap[1].x, startRouteMap[1].y);
      },
      [],
      this
    );

    this.playButton.on("pointerover", () => {
      this.playButton.setTexture("hover_playButton");
    });
    this.playButton.on("pointerout", () => {
      this.playButton.setTexture("playButton");
    });
    this.playButton.on("pointerup", () => {
      enablePointerEvents();
      config.audio.watering.stop();

      this.scene.stop("StartScene");
      // this.scene.start('GameSceneQ6');
      //this.scene.start('EndScene');
      // this.scene.start('GameSceneQ10');

      this.scene.start("TutorialScene");

    });
  }

  // this.time.delayedCall(1000, () => { },[],this);

  createPlants() {
    rect = new Phaser.Geom.Rectangle(229, 196, 791, 319);

    graphics = this.add.graphics({ lineStyle: { width: 2, color: 0x00ff00 }, fillStyle: { color: 0xff0000 } });

    // points = [];

    // var atlasTexture = this.textures.get('playSwayAnim');

    // var framesanim = atlasTexture.getFrameNames();

    while (points.length < 17) {
      var randomPoint = rect.getRandomPoint();

      var count = 0;

      if (points.length == 0) {
        points.push(randomPoint);
      } else {
        for (var j = 0; j < points.length; j++) {
          if (Phaser.Math.Distance.Between(points[j].x, points[j].y, randomPoint.x, randomPoint.y) > 70 && !(437 < randomPoint.x && randomPoint.x < 822 && 200 < randomPoint.y && randomPoint.y < 404)) {
            count++;
          }
        }
        if (count == points.length) {
          points.push(randomPoint);
        }
      }
    }

    graphics.clear();
    // graphics.strokeRectShape(rect);

    for (var i = 0; i < 4; i++) {
      var p = points[i];

      leafArray[i] = this.add.sprite(p.x, p.y, "flowering1Anim").setScale(0.3).setVisible(false);
      // leafArray[i].setFrame(Phaser.Math.Between(0, 37));
    }

    for (var i = 4; i < points.length; i++) {
      var p = points[i];

      leafArray[i] = this.add.sprite(p.x, p.y, "playSwayAnim").setScale(0.3);
      // leafArray[i].setFrame(Phaser.Math.Between(0, 37));
    }

    leafArray.forEach(function (element, index) {
      if (index >= 4) {
        element.play("plantssway");
      }

      // element.setFrame(Phaser.Math.Between(1, 37));
    }, this);
  }

  moveCan(fromX, fromY, toX, toY) {
    // this.getPositionCodeFromCoordinates(fromX,toX);

    // //>//>>>hidden_console.log(this.getPositionCodeFromCoordinates(fromX,fromY));

    // //>//>>>hidden_console.log(this.calculateDistance())

    this.time.delayedCall(
      2000,
      () => {
        this.waterThePlant(2000);
        leafArray[startRouteCount - 1].play("plantbudding").setVisible(true);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 3000,
      onComplete: () => {
        if (startRouteCount == 3) {
          leafArray[3].play("plantbudding").setVisible(true);
        }

        if (startRouteCount < startRouteMap.length - 1) {
          this.moveCan(startRouteMap[startRouteCount].x, startRouteMap[startRouteCount].y, startRouteMap[startRouteCount + 1].x, startRouteMap[startRouteCount + 1].y);

          startRouteCount = startRouteCount + 1;
          //>//>>>hidden_console.log(startRouteCount);
        }
      },
      onCompleteScope: this,
    });
  }

  waterThePlant(flowingtime) {
    //config.audio.watering.play();

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
